export const SEARCH_MIN_LENGTH = 2;

export const SEARCH_MIN_LENGTH_MESSAGE = 'minimum 2 characters needed';

export function isLocalSearchRuntime() {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1';
  }
  return false;
}

export function isBlankSearchQuery(query) {
  return (typeof query === 'string' ? query : '').trim() === '';
}

/** Empty search is allowed only when a shop category or subcategory is in scope. */
export function allowsBlankSearchSubmit({ shopSlug, subcategory } = {}) {
  if (isLocalSearchRuntime()) {
    return true;
  }
  if (subcategory) {
    return true;
  }
  return Boolean(shopSlug);
}

export function getSearchSubmitError(query, scope = {}) {
  if (allowsBlankSearchSubmit(scope)) {
    return null;
  }
  const len = (typeof query === 'string' ? query : '').trim().length;
  if (len < SEARCH_MIN_LENGTH) {
    return SEARCH_MIN_LENGTH_MESSAGE;
  }
  return null;
}

export function shouldSubmitSearch(query, scope) {
  return getSearchSubmitError(query, scope) === null;
}
